import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Users from "./pages/Users";
import AddUser from "./pages/AddUser";
import Clients from "./pages/Clients";
import UserDetail from "./pages/UserDetail";
import ClientDetail from "./pages/ClientDetail";
import AddClient from "./pages/AddClient";
import EditClient from "./pages/EditClient";
import AddPayment from "./pages/AddPayment";
import EditPayment from "./pages/EditPayment";
import ClientPayments from "./pages/ClientPayments";
import ProtectedRoute from "./components/ProtectedRoute"; // Import the protected route component
import Pages from "./pages/Pages";
import AddPage from "./pages/AddPage";
import EditPage from "./pages/EditPage";
import Page from "./pages/Page";
import EditUser from "./pages/EditUser";
import EditProfile from "./pages/EditProfile";
import Teams from "./pages/Teams";
import TeamDetails from "./pages/TeamDetails";
import CreateTeam from "./pages/CreateTeam";
import EditTeam from "./pages/EditTeam";
import Information from "./pages/Information"; // Import the Information component
import DeleteEmail from "./pages/DeleteEmail"; // Import the Information component
import SearchEmail from "./pages/SearchEmail"; // Import the Information component
import DatabaseTransaction from "./pages/DatabaseTransaction"; // Import the Information component
import OngageExport from "./pages/OngageExport"; // Import the Information component
import APIStats from "./pages/APIStats"; // Import the Information component
import PublicNavbar from "./components/PublicNavbar"; // Import PublicNavbar
import BASE_URL from "./config";
import MyTasks from "./pages/MyTasks";
import Search from "./pages/Search"; // Import the Search component
import ReoccurringTasks from "./pages/ReoccurringTasks";
import ClientsInformation from "./pages/ClientsInfo"; // Import the ClientsInformation component
import Jobs from "./pages/Jobs"; // Import the Jobs component
import Domain from "./pages/Domain"; // Import the Domain component
import Domains from "./pages/Domains"; // Import the Domains component
import AdminReoccurring from "./pages/AdminReoccurring";
import ShowLegacy from "./pages/ShowLegacy"; // Import ShowLegacy component
import ShowHensen from "./pages/ShowHensen";
import ShowRefinance from "./pages/ShowRefinance";
import ShowSolar from "./pages/ShowSolar";
import ShowRgrSuppressions from "./pages/ShowRgrSuppressions";
import ShowKeeper from "./pages/ShowKeeper";
import SchedulePost  from "./pages/SchedulePost";
import ForgotPassword from "./pages/ForgotPassword";
import UpdatePassword from "./pages/UpdatePassword";
import ChangePassword from "./pages/ChangePassword";
import MasterSuppressions from "./pages/MasterSuppressions";
import Keeper from "./pages/Keeper";
import DatabaseShrinker from "./pages/DatabaseShrinker";
import BenOngage from "./pages/BenOngage"; // Import BenOngage component
import BulkTaskAdder from "./pages/BulkTaskAdder"; // Import BulkTaskAdder component
import Warmup from "./pages/Warmup";
import WarmupClean from "./pages/WarmupClean";
import MergeCSV from "./pages/MergeCSV";
import DomainCount from "./pages/DomainCount";
import TemplateSetter from "./pages/TemplateSetter";
import Analytics from "./pages/Analytics";
import FirstPremierLending from "./pages/FirstPremierLending";
import EmailSorting from "./pages/EmailSorting";
import LizBuysHomes from "./pages/LizBuysHomes";
import BestRate from "./pages/BestRate";

import MergerCSV from "./pages/MergerCSV";
import Optizmo from "./pages/Optizmo";
import Emailer from "./pages/Emailer";

import SuppressionCleaningLog from "./pages/SuppressionCleaningLog";
import ImportWithProgress from "./pages/ImportWithProgress";

function Layout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await fetch(`${BASE_URL}api/pages/find-active`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setMenuItems(data);
      } catch (error) {
        console.error("Error fetching menu items:", error);
      }
    };

    fetchMenuItems();
  }, []);

  const hideSidebar =
    location.pathname === "/register" ||
    location.pathname === "/login" ||
    location.pathname === "/update-password" ||
    location.pathname === "/change-password" ||
    location.pathname === "/forgot-password" ||
    location.pathname.includes("/home");

  const isPublicPage =
    location.pathname === "/" ||
    menuItems.some((item) => location.pathname.includes(`/${item.slug}`));

  const isAuthenticated =
    localStorage.getItem("token") !== null && localStorage.getItem("token") !== "";

  const excludeLayoutRoutes = [
    "/show-legacy",
    "/show-refinance",
    "/show-rgrsuppressions",
    "/show-keeper",
     "/show-hensen",
       "/show-solar",
  ];
  const isMobile = window.innerWidth <= 768;


  const shouldExcludeLayout = excludeLayoutRoutes.includes(location.pathname);

  if (shouldExcludeLayout) {
    return (
      <Routes>
        <Route path="/show-legacy" element={<ProtectedRoute element={<ShowLegacy />} />} />
        <Route path="/show-hensen" element={<ProtectedRoute element={<ShowHensen />} />} />
        <Route path="/show-refinance" element={<ProtectedRoute element={<ShowRefinance />} />} />
        <Route path="/show-solar" element={<ProtectedRoute element={<ShowSolar />} />} />
        <Route path="/show-rgrsuppressions" element={<ProtectedRoute element={<ShowRgrSuppressions />} />} />
        <Route path="/show-keeper" element={<ProtectedRoute element={<ShowKeeper />} />} />
      </Routes>
    );
  }
  return (
    <div style={{ display: "flex" }}>
      {!hideSidebar && !isPublicPage && <Sidebar onToggle={setIsSidebarCollapsed} />}
      <div
        style={{
          marginLeft: hideSidebar || isPublicPage || isMobile ? "0px" : isSidebarCollapsed ? "40px" : "250px",
          transition: "margin-left 0.3s ease",
          width: isSidebarCollapsed ? "" : "100%",
        }}
      >
        <div style={{
          position: "sticky", 
          top: 0, 
          zIndex: 1000, 
          marginLeft: isSidebarCollapsed ? "10px" : ""}}>
          {isPublicPage ? <PublicNavbar /> : isAuthenticated && <Navbar />}
        </div>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/Pages" element={<Pages />} />
          <Route path="/warmup" element={<Warmup />} />
          <Route path="/warmupclean" element={<WarmupClean />} />
          <Route path="/mergecsv" element={<MergeCSV />} />
          <Route path="/domaincount" element={<DomainCount />} />
          <Route path="/firstpremierlending" element={<FirstPremierLending />} />
          <Route path="/suppressioncleaninglog" element={<SuppressionCleaningLog />} />
          <Route path="/importwithprogress" element={<ImportWithProgress />} />
          <Route path="/emailsorting" element={<EmailSorting />} />
          <Route path="/lizbuyshomes" element={<LizBuysHomes />} />
          <Route path="/bestrate" element={<BestRate />} />
          <Route path="/merger-csv" element={<MergerCSV />} />
          <Route path="/optizmo" element={<Optizmo />} />
          <Route path="/emailer" element={<Emailer />} />
          <Route path="/template-setter" element={<TemplateSetter />} />
          <Route path="/analytics" element={<Analytics />} />
          {/* Protected Routes */}
          <Route path="/users" element={<ProtectedRoute element={<Users />} />} />
          <Route path="/user-detail" element={<ProtectedRoute element={<UserDetail />} />} />
          <Route path="/clients" element={<ProtectedRoute element={<Clients />} />} />
          <Route path="/client-detail" element={<ProtectedRoute element={<ClientDetail />} />} />
          <Route path="/add-client" element={<ProtectedRoute element={<AddClient />} />} />
          <Route path="/client-payments" element={<ProtectedRoute element={<ClientPayments />} />} />
          <Route path="/edit-client" element={<ProtectedRoute element={<EditClient />} />} />
          <Route path="/add-payment" element={<ProtectedRoute element={<AddPayment />} />} />
          <Route path="/edit-payment" element={<ProtectedRoute element={<EditPayment />} />} />
          <Route path="/add-user" element={<ProtectedRoute element={<AddUser />} />} />
          {/* <Route path="/Pages" element={<ProtectedRoute element={<Pages />} />} /> */}
          <Route path="/add-page" element={<ProtectedRoute element={<AddPage />} />} />
          <Route path="/edit-page" element={<ProtectedRoute element={<EditPage />} />} />
          {/* <Route path="/Page/:pageName" element={<Page />} /> */}
          <Route path="/:pageName" element={<Page />} />
          <Route path="/edit-user" element={<ProtectedRoute element={<EditUser />} />} />
          <Route path="/edit-profile" element={<ProtectedRoute element={<EditProfile />} />} />
          <Route path="/teams" element={<ProtectedRoute element={<Teams />} />} />
          <Route path="/team-details" element={<ProtectedRoute element={<TeamDetails />} />} />
          <Route path="/create-team" element={<ProtectedRoute element={<CreateTeam />} />} />
          <Route path="/edit-team" element={<ProtectedRoute element={<EditTeam />} />} />
          <Route path="/information" element={<Information />} /> {/* Add route for Information */}
          <Route path="/search/:id" element={<Search />} /> 
          <Route path="/delete-email" element={<ProtectedRoute element={<DeleteEmail />} />} />
          <Route path="/search-email" element={<ProtectedRoute element={<SearchEmail />} />} />
          <Route path="/database-transaction" element={<ProtectedRoute element={<DatabaseTransaction />} />} />
          <Route path="/ongage-export" element={<ProtectedRoute element={<OngageExport />} />} />
          <Route path="/api-stats" element={<ProtectedRoute element={<APIStats />} />} />
          <Route path="/my-tasks" element={<ProtectedRoute element={<MyTasks />} />} />
          <Route path="/dashboard" element={<ProtectedRoute element={<MyTasks />} />} />
          <Route path="/reoccurring-tasks" element={<ProtectedRoute element={<ReoccurringTasks />} />} />
          <Route path="/clients-information" element={<ProtectedRoute element={<ClientsInformation />} />} />
          <Route path="/clients-information/:id" element={<ProtectedRoute element={<ClientsInformation />} />} />
          <Route path="/jobs" element={<ProtectedRoute element={<Jobs />} />} /> {/* Add route for Jobs */}
          <Route path="/domain" element={<ProtectedRoute element={<Domain />} />} /> {/* Add route for Domain */}
          <Route path="/domains" element={<ProtectedRoute element={<Domains />} />} /> {/* Add route for Domains */}
          <Route path="/admin-reoccurring" element={<ProtectedRoute element={<AdminReoccurring />} />}/>
          <Route path="/show-legacy" element={<ProtectedRoute element={<ShowLegacy />} />} />
          <Route path="/show-hensen" element={<ProtectedRoute element={<ShowLegacy />} />} />
          <Route path="/show-refinance" element={<ProtectedRoute element={<ShowRefinance />} />} />
          <Route path="/show-solar" element={<ProtectedRoute element={<ShowSolar />} />} />
          <Route path="/show-rgrsuppressions" element={<ProtectedRoute element={<ShowRgrSuppressions />} />} />
          <Route path="/show-keeper" element={<ProtectedRoute element={<ShowKeeper />} />} />
          <Route path="/schedule-post" element={<ProtectedRoute element={<SchedulePost />} />} />
          <Route path="/change-password" element={<ProtectedRoute element={<ChangePassword />} />} />
          <Route path="/master-suppressions" element={<MasterSuppressions />} />
          <Route path="/keeper" element={<Keeper />} />
          <Route path="/database-shrinker" element={<ProtectedRoute element={<DatabaseShrinker />} />} />
          <Route path="/ben-ongage" element={<ProtectedRoute element={<BenOngage />} />} /> {/* Add route for BenOngage */}
          <Route path="/bulk-task-adder" element={<ProtectedRoute element={<BulkTaskAdder />} />} /> {/* Add route for BulkTaskAdder */}
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}
export default App;
